/**
 * Created by huck on 15.06.18
 */
import {Component, Input, OnInit} from '@angular/core';
import ICourse from "ecoreps_shared/model/course";



@Component({
    selector: 'course-preview',
    templateUrl: './coursepreview.component.html',
    styleUrls: ['./coursepreview.component.scss']
})


export class CoursePreviewComponent implements  OnInit{

    @Input() public course :ICourse;

    ngOnInit(){

    }

    constructor(){
    }

}
